/**
 * Ruoli dell'utente (solo UX: il server resta autoritativo).
 *
 * I ruoli legacy hanno il nome suffissato per azienda (`amministratore-38`): si accetta il nome esatto
 * oppure il nome seguito da `-<numero>`, senza distinguere le maiuscole.
 */
export function haRuolo(roles: readonly string[] | null | undefined, nome: string): boolean {
  const base = nome.toLowerCase()
  return (roles ?? []).some((r) => {
    const x = (r ?? '').toLowerCase()
    return x === base || new RegExp(`^${base.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}-\\d+$`).test(x)
  })
}

/** Ruolo «amministratore» (`s:hasRole('amministratore')` del classico). */
export function haRuoloAmministratore(roles: readonly string[] | null | undefined): boolean {
  return haRuolo(roles, 'amministratore')
}
